import axios from '@/axios'

class MailDataService {
  getAllMails(page: number, search = ''): Promise<any> {
    return axios.get(`/mails/getAllMails?page=${page}&search=${encodeURIComponent(search)}`)
  }
  async getAllMailsForCompany(company_id: any, data: any): Promise<any> {
    return axios.get(`/mails/${company_id}/getAll?page=${data.page}`, data.body)
  }
  getMailById(id: any): Promise<any> {
    return axios.get(`/mails/${id}/get`)
  }
  add(data: any, envelopePhoto?: File | null): Promise<any> {
    // When an envelope photo is provided we MUST send it in the SAME HTTP
    // request as the row creation. The BE MailController queues a
    // notification email (Mail::queue(new NewMail(...))) immediately after
    // the row is committed, and with QUEUE_CONNECTION=sync the email fires
    // synchronously inside this same request — BEFORE a second upload
    // request from the browser could land. Sending the photo via a separate
    // POST /mails/{id}/upload-envelope-photo call after add() is a race:
    // the email always renders with envelope_photo = NULL, and the photo
    // never appears in the customer's inbox. The single-request pattern
    // here is the fix.
    if (envelopePhoto) {
      const formData = new FormData()
      for (const key of Object.keys(data)) {
        const value = (data as Record<string, any>)[key]
        // FormData.append stringifies everything; null/undefined become the
        // string "null"/"undefined" which Laravel treats as present. Skip
        // those to keep the BE validator happy.
        if (value !== null && value !== undefined) {
          formData.append(key, value as any)
        }
      }
      formData.append('envelope_photo', envelopePhoto)
      return axios.post('/mails/add', formData, {
        headers: { 'content-type': 'multipart/form-data' },
      })
    }
    return axios.post('/mails/add', data)
  }
  uploadImage(id: any, data: any): Promise<any> {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
    return axios.post(`/mails/${id}/uploadImage`, data, config)
  }
  uploadEnvelopePhoto(id: any, file: File): Promise<any> {
    const formData = new FormData()
    formData.append('envelope_photo', file)
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
    return axios.post(`/mails/${id}/upload-envelope-photo`, formData, config)
  }
  deleteEnvelopePhoto(id: any): Promise<any> {
    return axios.delete(`/mails/${id}/envelope-photo`)
  }
  update(id: any, data: any): Promise<any> {
    return axios.put(`/mails/${id}/update`, data)
  }
  bulkUpdateStatus(mailIds: number[], status: number): Promise<any> {
    return axios.put('/mails/bulk-update-status', { mail_ids: mailIds, status })
  }
  delete(id: any): Promise<any> {
    return axios.delete(`/mails/${id}/delete`)
  }
  getMailTypes(): Promise<any> {
    return axios.get('/mails/getMailTypes')
  }
  getMailStatuses(): Promise<any> {
    return axios.get('/mails/getMailStatuses')
  }
}
export default new MailDataService()
